import { render, staticRenderFns } from "./KSK.vue?vue&type=template&id=87766fb0&"
import script from "./KSK.vue?vue&type=script&lang=js&"
export * from "./KSK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports